console.warn('Initialized SkipToMainContent');

window.addEventListener('skipToMainContentClicked.um', function () {
  try {
    document.querySelector("#main-content").focus();
    document.querySelector(".skip-nav-focus").focus({ focusVisible: true });
  } catch (error) {
    console.warn('skipToMainContent FAIL reason:', error.message);
  }
})

